import { createFileRoute } from '@tanstack/react-router';

import { AppShellSkeleton } from '~/components/common/app-shell-skeleton/app-shell-skeleton';
import { CopilotShell } from '~/features/chat/components/copilot-shell/copilot-shell';
import { useFeatureFlagsSync } from '~/hooks/useFeatureFlagsSync';
import { useAuthStore } from '~/store/auth.store';
import { requireAuth } from '~/utils/guards';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: requireAuth,
  component: AuthLayout,
});

/**
 * Layout for authenticated routes.
 * Wraps content in CopilotShell (sidebar + chat/split layout).
 * Shows a loading skeleton while auth is still initializing (safety net).
 * Also keeps `auth.user.featureFlags` in sync with /feature-flags/me so admin
 * toggles propagate live without a re-login.
 */
function AuthLayout() {
  const isInitializing = useAuthStore((s) => s.isInitializing);
  useFeatureFlagsSync();

  if (isInitializing) {
    return <AppShellSkeleton />;
  }

  return <CopilotShell />;
}
